import { ActionIcon, Center, Modal, Space } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconCancel, IconCheck } from '@tabler/icons-react';
import { useParams } from 'react-router-dom';
import { SmallModal } from '../../../components/SmallModal';
import { Title } from '../../../components/Title';
import { mutate } from '../../../util/api/mutate';
import { useAddStaffPasswordForm } from '../hooks/useAddStaffPasswordForm';
import type { StaffPassword } from '../types/OperatorDto';
import { UpsertStaffPassword } from './UpsertStaffMemberComponents';

interface ResetPasswordModalProps {
	opened: boolean;
	close: () => void;
	accountId: string;
	username: string;
}

export function ResetPinModal({
	opened,
	close,
	accountId,
	username,
}: ResetPasswordModalProps) {
	const { organisation } = useParams();
	const { form, inputs } = useAddStaffPasswordForm(accountId);

	const closeAndReset = () => {
		form.reset();
		close();
		closeSuccessModal();
	};

	const [
		showSuccessModal,
		{ open: openSuccessModal, close: closeSuccessModal },
	] = useDisclosure(false);

	const resetPasswordMutation = mutate<StaffPassword>(
		`${organisation}/operators/reset-password`,
		inputs,
	);

	return (
		<>
			<Modal
				opened={opened}
				onClose={close}
				title={<Title label={'Reset Password'} />}
				w={100}
				withCloseButton={false}
				size={'sm'}
			>
				<SmallModal
					isOpen={showSuccessModal}
					close={closeSuccessModal}
					title={'Password Reset!'}
					body={
						<>
							Password for <i>{username}</i> has been successfully reset. Click
							Ok to continue...
						</>
					}
					onComplete={() => {
						closeAndReset();
					}}
				/>
				<form
					onSubmit={form.onSubmit(async () => {
						await resetPasswordMutation.mutateAsync().then((response) => {
							if (response.isValid) {
								openSuccessModal();
							}
						});
					})}
				>
					<UpsertStaffPassword form={form} />
					<Space h={50} />
					<Center>
						<ActionIcon
							variant={'filled'}
							aria-label={'Settings'}
							color={'medepos.1'}
						>
							<IconCancel
								style={{ width: '70%', height: '70%' }}
								stroke={1.5}
								onClick={() => {
									closeAndReset();
								}}
							/>
						</ActionIcon>
						<Space w={20} />
						<ActionIcon
							variant={'filled'}
							aria-label={'Settings'}
							color={'medepos.1'}
							type={'submit'}
						>
							<IconCheck style={{ width: '70%', height: '70%' }} stroke={1.5} />
						</ActionIcon>
					</Center>
				</form>
			</Modal>
		</>
	);
}
